import React from 'react';

/**
 * Exámenes y procedimientos que el médico solicita en esta atención.
 *
 * Reemplaza al campo de texto libre "Órdenes y procedimientos": estructurado se
 * puede imprimir como orden independiente que el paciente lleva al laboratorio.
 *
 * Apagar la casilla NO borra lo escrito: solo marca que no se imprime.
 */
const CATEGORIES = ['Laboratorio', 'Imagenología', 'Procedimiento', 'Interconsulta', 'Otro'];
const PRIORITIES = ['Rutina', 'Prioritario', 'Urgente'];

const emptyRow = () => ({ name: '', category: '', priority: 'Rutina', indication: '' });

function RequestedTestsSection({ value, onChange }) {
  const items = value?.items || [];

  const setItems = (next) => onChange({ ...value, items: next });
  const setItem = (index, field, fieldValue) =>
    setItems(items.map((item, i) => (i === index ? { ...item, [field]: fieldValue } : item)));

  return (
    <div className="border-t pt-6">
      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={!!value?.enabled}
          onChange={(e) => onChange({ ...value, enabled: e.target.checked })}
          className="h-4 w-4"
        />
        <span className="text-lg font-semibold text-gray-900">
          Incluir exámenes / procedimientos solicitados
        </span>
      </label>
      <p className="text-sm text-gray-500 ml-6 mb-4">
        Genera además una orden independiente en PDF.
      </p>

      {value?.enabled && (
        <div className="space-y-3">
          {items.map((item, index) => (
            <div key={index} className="grid grid-cols-12 gap-2 items-end">
              <div className="col-span-4">
                <label htmlFor={`test-name-${index}`} className="block text-xs text-gray-500">
                  Examen
                </label>
                <input
                  id={`test-name-${index}`}
                  className="w-full border rounded px-3 py-2"
                  placeholder="Examen o procedimiento"
                  value={item.name || ''}
                  onChange={(e) => setItem(index, 'name', e.target.value)}
                />
              </div>

              <div className="col-span-3">
                <label htmlFor={`test-category-${index}`} className="block text-xs text-gray-500">
                  Tipo
                </label>
                <select
                  id={`test-category-${index}`}
                  className="w-full border rounded px-3 py-2"
                  value={item.category || ''}
                  onChange={(e) => setItem(index, 'category', e.target.value)}
                >
                  <option value="">—</option>
                  {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>

              <div className="col-span-2">
                <label htmlFor={`test-priority-${index}`} className="block text-xs text-gray-500">
                  Prioridad
                </label>
                <select
                  id={`test-priority-${index}`}
                  className="w-full border rounded px-3 py-2"
                  value={item.priority || 'Rutina'}
                  onChange={(e) => setItem(index, 'priority', e.target.value)}
                >
                  {PRIORITIES.map((p) => <option key={p} value={p}>{p}</option>)}
                </select>
              </div>

              <div className="col-span-2">
                <label htmlFor={`test-indication-${index}`} className="block text-xs text-gray-500">
                  Indicación
                </label>
                <input
                  id={`test-indication-${index}`}
                  className="w-full border rounded px-3 py-2"
                  placeholder="Indicación clínica"
                  value={item.indication || ''}
                  onChange={(e) => setItem(index, 'indication', e.target.value)}
                />
              </div>

              <button
                type="button"
                aria-label={`Quitar examen ${index + 1}`}
                className="col-span-1 text-red-600 pb-2"
                onClick={() => setItems(items.filter((_, i) => i !== index))}
              >
                Quitar
              </button>
            </div>
          ))}

          <button
            type="button"
            className="text-primary-600 font-medium"
            onClick={() => setItems([...items, emptyRow()])}
          >
            + Agregar examen
          </button>

          <textarea
            className="w-full border rounded px-3 py-2"
            rows={2}
            placeholder="Observaciones"
            value={value?.notes || ''}
            onChange={(e) => onChange({ ...value, notes: e.target.value })}
          />
        </div>
      )}
    </div>
  );
}

export default RequestedTestsSection;
